import React from 'react';
import { StatCard } from '../../shared/StatCard';

const MailjetStatsTab = ({ stats, loading, onRefresh }) => {
  const recent = Array.isArray(stats.recentMessages) ? stats.recentMessages : [];

  // Derive basic stats from recent messages (API does not provide summarized stats reliably)
  const derivedCounts = recent.reduce(
    (acc, msg) => {
      const status = String(msg?.status || '').toLowerCase();
      if (status === 'sent') acc.sent += 1;
      if (status === 'opened' || status === 'open') acc.opened += 1;
      if (status === 'clicked' || status === 'click') acc.clicked += 1;
      if (status.includes('bounce')) acc.bounced += 1; // handle soft/hard bounce if present
      return acc;
    },
    { sent: 0, opened: 0, clicked: 0, bounced: 0 }
  );
  const openRate = derivedCounts.sent > 0 ? `${Math.round((derivedCounts.opened / derivedCounts.sent) * 100)}%` : '0%';
  const clickRate = derivedCounts.sent > 0 ? `${Math.round((derivedCounts.clicked / derivedCounts.sent) * 100)}%` : '0%';
  const bounceRate = derivedCounts.sent > 0 ? `${Math.round((derivedCounts.bounced / derivedCounts.sent) * 100)}%` : '0%';

  const basic = {
    sent: derivedCounts.sent,
    opened: derivedCounts.opened,
    clicked: derivedCounts.clicked,
    openRate,
    clickRate,
    bounceRate
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Mailjet Email Statistics</h2>
        <button 
          onClick={onRefresh}
          disabled={loading}
          className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-4 rounded flex items-center"
        >
          <i className={`fa-solid fa-sync-alt mr-2 ${loading ? 'animate-spin' : ''}`}></i>
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div>

      {/* Basic Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard title="Emails Sent" value={loading ? 'Loading...' : basic.sent.toLocaleString()} icon="fa-paper-plane" color="blue" />
        <StatCard title="Opened" value={loading ? 'Loading...' : basic.opened.toLocaleString()} icon="fa-envelope-open" color="green" />
        <StatCard title="Clicked" value={loading ? 'Loading...' : basic.clicked.toLocaleString()} icon="fa-mouse-pointer" color="yellow" />
        <StatCard title="Open Rate" value={loading ? 'Loading...' : basic.openRate} icon="fa-chart-line" color="purple" />
      </div>

      {/* Event Breakdown container removed per request */}

      {/* Recent Emails Table */}
      <div className="bg-white border rounded-lg p-4 mb-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Recent Emails</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">To</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Subject</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {recent.map((msg, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{msg.to}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{msg.subject}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{msg.status}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{msg.date ? new Date(msg.date).toLocaleString() : '-'}</td>
                </tr>
              ))}
              {recent.length === 0 && (
                <tr>
                  <td className="px-6 py-4 text-sm text-gray-500" colSpan="4">No recent emails.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MailjetStatsTab;


